import { create } from 'zustand';

type TResearchPageCoverTheme = 'light' | 'dark' | null;
interface HeaderStore {
  isIntersectingWithCover: boolean;
  setIsIntersectingWithCover: (isIntersecting: boolean) => void;
  researchPageCoverTheme: TResearchPageCoverTheme;
  setResearchPageCoverTheme: (
    researchPageCoverTheme: TResearchPageCoverTheme
  ) => void; // isIntersectingWithProjectCover: boolean;
  // setIsIntersectingWithProjectCover: (isIntersecting: boolean) => void;
  headerHeight: number;
  setHeaderHeight: (headerHeight: number) => void;
}

export const useHeaderStore = create<HeaderStore>((set) => ({
  isIntersectingWithCover: false,
  setIsIntersectingWithCover: (isIntersectingWithCover) =>
    set({ isIntersectingWithCover }),
  researchPageCoverTheme: null,
  setResearchPageCoverTheme: (researchPageCoverTheme) =>
    set({ researchPageCoverTheme }),

  // isIntersectingWithProjectCover: false,
  // setIsIntersectingWithProjectCover: (isIntersecting) =>
  //   set({ isIntersectingWithProjectCover: isIntersecting }),
  headerHeight: 0,
  setHeaderHeight: (headerHeight) => set({ headerHeight }),
}));
